import { toast } from 'react-toastify';

const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

export const classNameInput = `containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white`
export const urlApiTMAN = process.env.REACT_APP_TMAN_API

export const formatDate = (date, format = 103) => {
    let stringFormat = ''
    switch  (format) {
        case 23:
            stringFormat = [
                date.getFullYear(),                
                padTo2Digits(date.getMonth() + 1),
                padTo2Digits(date.getDate())
            ].join('-');
            break;
        case 103:
            stringFormat = [
                padTo2Digits(date.getDate()),
                padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
            break;
        default:
            console.error('Ingreso un formato no valido mapeado')
    }

    return stringFormat;
}

export const capitalLetter = (string) => {
    return (string ? `${string[0].toUpperCase()}${string.slice(1).toLowerCase()}` : '')
}

//==================FUNCIONES CONVERSION DIAS========================
export const dateToString = (date) => {
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`
}
export const stringToDate = (string) => {
    const [dia,mes,anio] = string.split('/');
    return new Date(anio, mes - 1 , dia);
}

export const dateTimeToString = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}
export const stringToDateTime = (string) => {
    const [datePart, timePart] = string.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes);
}

export const dateAddDays = (days = 0, date = new Date()) => {
    date.setDate(date.getDate() + days)
    return date
}
//=====================================================================

export const stringToNewDate = (fechaString) => {
    const partesFecha = fechaString.split('/');
    const dia = partesFecha[0];
    const mes = partesFecha[1];
    const año = partesFecha[2];
    const fecha = new Date(`${año}-${mes}-${dia}`);
    const fechaFormateada = fecha.toISOString();

    return fechaFormateada;
}

export const notify = (title, type, options = {}) => {
    toast[type](title, {
        position: options.position ?? "top-right",
        autoClose: options.autoClose ?? 5000,
        hideProgressBar: options.hideProgressBar ?? false,
        closeOnClick: options.closeOnClick ?? true,
        pauseOnHover: options.pauseOnHover ?? true,
        draggable: true,
        progress: undefined,
    });
}

// export const notify = (title, type, options = {}) => {
//     toast[type](title, {
//         position: options.position ?? "top-center",
//         autoClose: options.autoClose ?? 5000,
//         hideProgressBar: options.hideProgressBar ?? false,
//         closeOnClick: options.closeOnClick ?? true,
//         pauseOnHover: options.pauseOnHover ?? true,
//         draggable: true,
//         progress: undefined,
//         theme: "colored",
//     });
// }









export const soloCelular = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{8}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloNumero = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{20}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDNI = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{7}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDecimal = (e, elemento) => {
    const key = e.keyCode ? e.keyCode : e.which

    if (key === 8) return true
    
    if (key > 47 && key < 58) {
        if (elemento.value === "") return true
        const regexp = /.[0-9]{9}$/

        if(!(regexp.test(elemento.value))) {
            return true
        }
    }

    if (key === 46) {
        if (elemento.value === "") return false
        const regexp = /^[0-9]+$/
        console.log("s ", regexp.test(elemento.value))
        if (regexp.test(elemento.value)) {
            return true
        }
    }
    
    e.preventDefault()
}

export const formatState = (codState) => {
    let htmlrespuesta = '';
    
    let className 
    let color 
    if ([1,9].includes(codState)) color = 'bg-yellow-600'
    else if ([2,18].includes(codState)) color = 'bg-green-600'
    else if ([3,39].includes(codState)) color = 'bg-red-600'
    else color = 'gray'
    className = `cursor-pointer ${color} px-2 py-[2px] rounded text-[11px] font-bold`
    return className;
}


export const primeraLetraMayuscula = (string) => {
    var str = string;

    str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });

    return str; 
}

export const todoMayuscula = (string)=> {
    var str = string;
    str = str.toUpperCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
    return str;
}

export const quitarTildes = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
} 


export const enviarImagenMinio = async ({       // GUARDA LA IMAGEN EN EL MINIO Y LA RETORNA A DONDE SE EJECUTA LA FUNCION
    nombreCarpeta,
    nombreArchivo,
    file
}) => {
    const url = `https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?NombreCarpeta=${nombreCarpeta}&NombreArchivo=${nombreArchivo}`
    const urlVer =`https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nombreCarpeta}&NombreImagen=${nombreArchivo}`

    const formData = new FormData();
    const blob  = file.slice(0,file.size,'aplication/json');
    const newfile = new File([blob],file.name,{type:'aplication/json'})
    formData.append("archivo", newfile)

    try {
        const response = await fetch(url,{
            method:'POST',
            body: formData
        }).then(res => res.json())

        response.isValid ? notify('Imagen guardada correctamente','success') : notify('Ocurrio un error al guardar la imagen','error')
        return (response.isValid ? urlVer : '')
    } catch (error) {
        notify('Ocurrio un error al guardar la imagen','error')
        return ''
    }

}
